import React from 'react';
import { dexaCreditsGranted, dexaCreditsCopy } from '@/data/dexaAddOn';

// BE #349 — on the confirmation screen, tell the patient how many DEXA scan
// credits they now hold and where to book them. Renders ONLY when the payment
// response says credits were granted (`dexaCredits`), so it never promises a
// credit while the backend's DEXA_CREDITS_ENABLED is off, and it never implies
// a slot is already booked.
const DexaCreditsNote = ({ answers, paymentResult }) => {
  const n = dexaCreditsGranted(paymentResult || (answers && answers.payment));
  if (!n) return null;
  return (
    <div className="mt-4 rounded-xl border border-[#2d8a5f]/30 bg-[#f0faf4] p-4 text-sm text-gray-800 text-left" data-testid="dexa-credits-note">
      {dexaCreditsCopy(n)}
    </div>
  );
};

export default DexaCreditsNote;
